import { z } from "zod";
import { AD_UPGRADE_VARIANT_KEY_SCHEMA } from "./AdUpgradeVariantKey";
import { AD_PACKAGE_KEY_SCHEMA } from "./AdPackageKey";
import { AD_UPGRADE_KEY_SCHEMA } from "./AdUpgradeKey";

const AD_PACKAGE_CHOICE_KEY_SCHEMA = z.object({
  type: z.literal("PACKAGE"),
  product: AD_PACKAGE_KEY_SCHEMA,
  variant: z.literal("NONE")
});

const AD_UPGRADE_CHOICE_KEY_SCHEMA = z.object({
  type: z.literal("UPGRADE"),
  product: AD_UPGRADE_KEY_SCHEMA,
  variant: AD_UPGRADE_VARIANT_KEY_SCHEMA
});

export const AD_PRODUCT_CHOICE_KEY = z.union([
  AD_PACKAGE_CHOICE_KEY_SCHEMA,
  AD_UPGRADE_CHOICE_KEY_SCHEMA
], "Invalid product choice key");

export type AdProductChoiceKey = z.infer<typeof AD_PRODUCT_CHOICE_KEY>;

export type AdPackageChoiceKey = z.infer<typeof AD_PACKAGE_CHOICE_KEY_SCHEMA>;

export type AdUpgradeChoiceKey = z.infer<typeof AD_UPGRADE_CHOICE_KEY_SCHEMA>;
